<template>
  <layout-vertical>

    <router-view />

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />

  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'
import { ref, onMounted } from '@vue/composition-api';
export default {
  props: {},
  components: {
    AppCustomizer,
    LayoutVertical,
  },
  directives: {},
  setup(props, context) {
    const showCustomizer = ref($themeConfig.layout.customizer)
    const permissions = ref(JSON.parse(localStorage.getItem('userData')).permissions)

    onMounted(() => {
      showCustomizer.value = permissions.value.filter((e) => e.action === 'system-settings').length > 0
                          ? true
                          : showCustomizer.value
    })
    
    return {
      showCustomizer,
    }
  }
}
</script>
